import { absoluteTime, formatTime } from "../data";
import { useState } from 'react';
import ResourceTooltip from './ResourceTooltip';
import { Tooltip } from 'react-tooltip';
import { useDragContext } from './DragContext';

export const StandardActionView = ({startTime, action, onMoveAction, onDeleteAction, onToggleDeactivate, onToggleDone, last}) => {
    // Determine if the action is deactivated or done
    const isDeactivated = action.deactivated === true;
    const isDone = action.done === true;
    const [showTooltip, setShowTooltip] = useState(false);
    const { isDragging } = useDragContext();
    
    // Check if we have state data to show in tooltip
    const hasStateData = action.stateAfter || action.stateBefore;
    
    // Don't show tooltip when dragging
    const shouldShowTooltip = showTooltip && !isDragging && hasStateData;
    
    return (
        <li 
          key={action.index} 
          className={"col-span-1 m-0 p-1 rounded-sd shadow-sd flex justify-between items-start " + 
            (isDeactivated ? "bg-gray-600 opacity-70 " : action.valid ? "bg-gray-800 " : "bg-red-400 ") + 
            ("col-start-" + action.planetId)}
          data-tooltip-id={`tooltip-${action.index}`}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
              <div>
                {/* Action Summary */}
                <div className={"font-semibold text-left " + (isDeactivated ? "text-gray-400" : "text-gray-200")}>
                  {isDeactivated ? "[Deactivated] " : ""}{action.summary}
                </div>
                {/* Start Time and End Time */}
                <div className="text-sm text-gray-400 text-left">
                  Start: {absoluteTime(startTime, action.startTime)} | End: {absoluteTime(startTime, action.endTime)}
                </div>
              </div>
              
              {/* Tooltip */}
              {shouldShowTooltip && (
                <Tooltip
                  id={`tooltip-${action.index}`}
                  place="right"
                  className="z-50"
                  style={{ backgroundColor: 'transparent', padding: 0, border: 'none' }}
                >
                  <ResourceTooltip 
                    beforeState={action.stateBefore} 
                    afterState={action.stateAfter} 
                  />
                </Tooltip>
              )}
              {/* Action Control Buttons */}
              {action.editable && (
                <div className="flex items-center space-x-1">
                  {/* Move Up Button */}
                  {action.index !== 0 && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'up')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={action.index === 0} // Disable if it's the first item
                    >
                      ▲
                    </button>
                  )}

                  {/* Move Down Button */}
                  { !last && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'down')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={last} // Disable if it's the last item
                    >
                      ▼
                    </button>
                  )}
                  
                  {/* Toggle Deactivate Button */}
                  <button
                    onClick={() => onToggleDeactivate(action.planetId, action.index)}
                    className={(isDeactivated ? "bg-green-600 hover:bg-green-700" : "bg-yellow-600 hover:bg-yellow-700") + " text-white px-2 rounded text-xs"}
                    title={isDeactivated ? "Activate" : "Deactivate"}
                  >
                    {isDeactivated ? "✓" : "⏸"}
                  </button>

                  {/* Delete Button */}
                  <button
                    onClick={() => onDeleteAction(action.planetId, action.index)}
                    className="bg-red-600 hover:bg-red-700 text-white px-2 rounded text-xs"
                  >
                    X
                  </button>
                </div>
              )}
              
            </li>
    );
}